import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import { CustomEase } from "gsap/CustomEase";
import { animationLoader } from "./animationLoader";
import { initNav, setMenuToggleFunction } from "./mobileNavigation.js";
import { unLazyLoad } from "./unlazyLoad";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { LDScrollTo } from "./scrollTo.js";
import { slideDown, slideUp } from "./slideupSlidedown.js";
import { LD_Custom_Eases } from "./customEases";

gsap.registerPlugin( Flip, ScrollTrigger, Observer, ScrollToPlugin, CustomEase );

// Establish Custom Eases
const ce = new LD_Custom_Eases();

const createElement = function ( parentEl = document, elTag = 'div', classes = [] ) {
  let newEl = document.createElement( elTag );
  if ( classes.length > 0 ) {
    classes.forEach( thisClass => {
      newEl.classList.add( thisClass );
    } )
  }
  parentEl.prepend( newEl );

  return newEl;
}

const logMenu = function ( menuObj ) {
  //
  const html = document.querySelector('html');

  // Main Mobile Nav
  if ( false === menuObj.classList.contains( 'sub-menu' ) ) {
    
    if ( false === menuObj.classList.contains( 'active' ) ) {
      
      html.style.overflow = null;
      
      gsap.to( menuObj, {
        opacity: 1,
        x: "200vw",
        duration: 0.3,
        ease: 'exiting',
        onComplete: function () {
          menuObj.style.display = 'none';
        }
      } );

    }
    else {
      
      html.style.overflow = "hidden";
      
      gsap.fromTo( menuObj, {
        display: 'block',
        duration: 0.001,
        opacity: 1,
        x: "200vw",
      }, {
        opacity: 1,
        x: "0vw",
        duration: 0.5,
        ease: 'entering'
      } );
    }
  }
  // Sub Menus
  else {
    if ( false === menuObj.classList.contains( 'active' ) ) {
      slideUp( menuObj, 0.2 );
    }
    else {
      slideDown( menuObj, 0.3 );
    }
  }
}

const getWindowWidth = function () {
  return window.outerWidth;
}

window.addEventListener( 'DOMContentLoaded', event => {

  // Home Hero
  const homeHeroCover = document.querySelector( 'body.home .home-hero' );

  if ( null !== homeHeroCover ) {
    let homeTL = gsap.timeline( {
      paused: true
    } );

    let heroImage = homeHeroCover.querySelector( '*[class*="__image-background"]' );

    if ( null !== heroImage ) {
      gsap.set( heroImage, {
        filter: "grayscale(1) contrast(1.2)"
      } );

      homeTL.to( heroImage, {
        opacity: 1,
        duration: 2,
        ease: 'entering'
      }, "+1.5" ).to( heroImage, {
        filter: "grayscale(0) contrast(1)",
        duration: 2,
        ease: 'ease-in(1.2)'
      }, "+2.5" );

    }

    let heroShade = createElement( homeHeroCover, 'div', ['hero-shade'] );

    homeTL.to( heroShade, {
      // y: "-33vw",
      bottom: '0%',
      // opacity: 0,
      duration: 2.5,
      ease: 'entering'
    }, "+2" );

    let heroContent = homeHeroCover.querySelector( '*[class*="__inner-container"]' );

    if ( null !== heroContent ) {
      gsap.set( heroContent, {
        opacity: 0,
        zIndex: 3
      } );

      // Candle Flicker
      // homeTL.to( heroContent, {
      //   opacity: 1,
      //   ease: 'ease-out',
      //   duration: 0.7
      // });
      // homeTL.to( heroContent, {
      //   textShadow: "0px 0px 30px white",
      //   ease: 'ease-in',
      //   duration: 0.8,
      //   repeat: 1,
      //   yoyo: true
      // }, "<");

      // homeTL.to( heroContent, {
      //   opacity: 0.67,
      //   ease: "rough",
      //   duration: 0.3,
      //   repeat: 2,
      //   yoyo: true
      // }, ">");

      //  homeTL.to( heroContent, {
      //   opacity: 1,
      //   ease: 'ease-out',
      //   duration: 0.5
      // }, ">");

      // Rise and light
      gsap.set( heroContent, {
        y: 100
      } );

      homeTL.to( heroContent, {
        opacity: 1,
        ease: 'ease-in',
        duration: 0.7
      }, "+0.5" );
      homeTL.to( heroContent, {
        y: 0,
        ease: 'entering',
        duration: 1.2
      }, "<" );

      homeTL.to( heroContent, {
        textShadow: "0px 0px 30px #FFF7EB", // background-color
        ease: 'ease-out',
        duration: 0.8,
        repeat: 1,
        repeatDelay: 0.5,
        yoyo: true
      }, "<" );

    }

    window.addEventListener( 'load', () => {
      homeTL.play();
    } );
  }

  // Single Header
  const entryHeaderImage = document.querySelector( '.entry-header .entry-header-image, .archive-header .entry-header-image' );

  let headerTL = gsap.timeline( {
    ease: 'entering',
    paused: true
  } );

  if ( null !== entryHeaderImage ) {
    const entryHeaderImagePlaceholder = entryHeaderImage.querySelector('img.blur');
    const entryHeaderImageTitle = document.querySelector( '.entry-header .entry-header-image + .entry-title' );
    const headerShade = entryHeaderImage.querySelector('.header-shade');
    
    if( null !== entryHeaderImagePlaceholder ){
      headerTL.to( entryHeaderImagePlaceholder, {
        opacity: 0,
        duration: 0.33,
        ease: 'exiting',
        onComplete: function(){
          entryHeaderImagePlaceholder.remove();
        }
      });
    }

    headerTL.to( headerShade, {
      y: "-33vw",
      opacity: 0,
      duration: 2.25,
      delay: 0.33,
      onComplete: function(){
        headerShade.remove();
      }
    } );

    if ( null !== entryHeaderImageTitle ) {

      headerTL.to( entryHeaderImageTitle, {
        textShadow: "3px 0px 20px rgba(0, 0, 0, 0.82)",
        // y: -5,
        duration: 1
      }, "=-0.5" );
    }

    window.addEventListener( 'load', () => {
      headerTL.play();
    } );
  }

  // Concert Header
  const concertHeader = document.querySelector( 'body.single-concert .entry-title' );

  // if ( null !== concertHeader && getWindowWidth() > 760 ) {

  //   let concertTL = gsap.timeline( {
  //     paused: true
  //   } );

  //   // Rise and light
  //   // gsap.set( concertHeader, {
  //   //   y: 100
  //   // });

  //   // concertTL.to( concertHeader, {
  //   //   opacity: 1,
  //   //   ease: 'ease-in',
  //   //   duration: 0.7
  //   // }, "+0.5");
  //   // concertTL.to( concertHeader, {
  //   //   y: 0,
  //   //   ease: 'entering',
  //   //   duration: 1.2
  //   // }, "<");

  //   concertTL.to( concertHeader, {
  //     textShadow: "0px 0px 30px #FFF7EB", // background-color
  //     ease: 'ease-out',
  //     duration: 0.8,
  //     repeat: 1,
  //     repeatDelay: 0.5,
  //     yoyo: true
  //   }, "<" );

  //   window.addEventListener( 'load', () => {
  //     concertTL.play();
  //   } );

  // }

  const slideInRights = document.querySelectorAll( '*.slide-in-from-right' );

  if ( slideInRights.length > 0 && getWindowWidth() > 600 ) {
    slideInRights.forEach( thisSir => {
      let thisSirParent = thisSir.parentElement;
      let sirTL = gsap.timeline( {
        delay: 0.33,
        paused: true
      } );

      gsap.set( thisSir, {
        x: "100vw",
        y: -20,
        rotate: 30,
        boxShadow: "200px -100px 200px rgba(0,0,0,0.3)"
      } );

      sirTL.to( thisSir, {
        x: "0vw",
        y: 0,
        rotate: 0,
        boxShadow: "3px -2px 8px rgba(0,0,0,0.5)",
        duration: 1,
        ease: 'entering'
      } );

      thisSirParent.addEventListener( 'aniActive', () => {
        sirTL.play();
      } );

    } );

    const aniLoad = new animationLoader( '*:has(>.slide-in-from-right)' );
  }

  const slideInLefts = document.querySelectorAll( '*.slide-in-from-left' );

  if ( slideInLefts.length > 0 && getWindowWidth() > 600 ) {
    slideInLefts.forEach( thisSil => {
      let thisSilParent = thisSil.parentElement;
      let silTL = gsap.timeline( {
        delay: 0.33,
        paused: true
      } );
      gsap.set( thisSil, {
        x: "-100vw",
        y: -20,
        rotate: -30,
        boxShadow: "-200px 100px 200px rgba(0,0,0,0.3)"
      } )
      silTL.to( thisSil, {
        x: "0vw",
        y: 0,
        rotate: 0,
        boxShadow: "-3px 2px 8px rgba(0,0,0,0.5)",
        duration: 1.5,
        delay: 0.2,
        ease: 'entering'
      } );

      thisSilParent.addEventListener( 'aniActive', () => {
        silTL.play();
      } );
    } );

    const aniLoad = new animationLoader( '*:has(>.slide-in-from-left)' );
  }

} );


// The following components add their own event listeners.
unLazyLoad();
initNav();
setMenuToggleFunction( logMenu );
const aniLoad = new animationLoader();
const scroller = new LDScrollTo( 1, '100px');